// extracted by mini-css-extract-plugin
export default {"settingsButton":"settings-button_settingsButton__H3MiI","settingsLogo":"settings-button_settingsLogo__kf3z7","settingsText":"settings-button_settingsText__XIINc"};